import { useMutation } from '@tanstack/react-query';
import { updateCustomerIdentity } from '@Pages/happyFlowPages/identity/api/identity.api.ts';

export const useUpdateIdentity = (onSuccess: () => void) =>
  useMutation({
    mutationFn: updateCustomerIdentity,
    mutationKey: ['updateCustomerIdentity'],
    onSuccess: () => onSuccess(),
  });
